module.exports = __webpack_public_path__ + "static/xunxun-8c73343dd714a21a4a5a70771fd030f6.jpg";